/**
 *  全域常用函式。
 *  已在 `@/mixins/common.js` 中 import，所以可以在所有組件裡呼叫這些方法。
 */

import moment from 'moment'
import global from './global'
import bankCode from '@/assets/json/taiwanBankCode.json'

/**
 * 將 timestamp 轉換為可讀的字串
 * @param  {Number} _ timestamp
 * @return {String}   時間字串
 */
const convertTime = _ => {
  if (_) return moment(+_).format('YYYY-MM-DD HH:mm')
  return _
}

/**
 * 將`組別編號`轉換成中文字串
 * @param  {Number} _ 組別編號
 * @return {String}   組別中文字串
 */
const convertGroupText = _ => {
  if (!_) return null
  return global.groupTable[_] || _
}

/**
 * 將`設備 key`轉換成中文字串
 * @param  {Number} _ 設備 key
 * @return {String}   設備中文字串
 */
const convertEquipmentText = _ => {
  if (!_) return null
  return global.equipmentTable[_] || _
}

/**
 * 將`賽制編號`轉換成中文字串
 * @param  {Number} _ 賽制編號
 * @return {String}   賽制中文字串
 */
const convertLevelText = _ => {
  if (!_ || _ === -Infinity || _ === Infinity) return null
  return global.levelTable[_] || _
}

/**
 * 將`繳費狀態編號`轉換成繳費狀態物件
 * @param  {Number} _ 繳費狀態編號
 * @return {Object}   繳費狀態物件
 */
const convertFormStatusObject = _ => {
  if (!_) return {}
  return global.formStatusTable[+_] || {}
}

/**
 * 將`繳費狀態編號`轉換成繳費狀態字串
 * @param  {Number} _ 繳費狀態編號
 * @return {String}   繳費狀態字串
 */
const convertFormStatusText = _ => {
  if (!_) return {}
  return global.formStatusTable[+_].name || _
}

/**
 * 檢查電話號碼格式是否合法
 * @param  {String}  _ 電話號碼字串
 * @return {Boolean}
 */
const checkPhoneValidity = _ => {
  _ += ''
  try {
    return /^0\d{2,3}-?\d{7,8}$/.test(_)
  } catch (e) {
    return false
  }
}

/**
 * 將`銀行代碼`轉換成銀行中文名稱
 * @param  {Number} _ 銀行代碼
 * @return {String}   銀行中文名稱
 */
const convertBankCode = _ => {
  const result = bankCode.find(i => +_ === +i.code)
  return result.name || ''
}

/**
 * 隨機從陣列中抽取一項
 * @param  {Array} _ 陣列
 * @return {Any}   抽出的項目
 */
const randomPick = _ => {
  try {
    return _[Math.floor((Math.random() * _.length))]
  } catch (e) {
    return null
  }
}

const addIdToListItems = _ => {
  const randomString = require('random-base64-string')
  if (!Array.isArray(_)) return _

  return _.map(item =>
    !item._id
      ? { ...item, _id: randomString(6) }
      : { ...item }
  )
}

const removeIdFromListItems = _ => {
  if (!Array.isArray(_)) return _

  return _.map(item => {
    item = { ...item }
    delete item._id
    return item
  })
}

export default {
  convertTime,
  convertGroupText,
  convertEquipmentText,
  convertLevelText,
  convertFormStatusObject,
  convertFormStatusText,
  checkPhoneValidity,
  convertBankCode,
  randomPick,
  addIdToListItems,
  removeIdFromListItems,
}
